import { apiClient } from '@/api/client'

export interface TopicState {
  is_subscribed: boolean
  is_custom: boolean
  /** Which level decided is_subscribed: an individual (custom) setting, the
   * site's "Subscribe by severity" rule, the fleet default, or nothing. */
  source?: 'individual' | 'site_severity' | 'fleet_default' | 'none'
}

export interface SystemSubscriptionsResponse {
  subscribed_alarm_topic_ids: number[]
  topics: Record<string, TopicState>
}

export async function fetchSystemSubscriptions(controllerId: string): Promise<SystemSubscriptionsResponse> {
  const { data } = await apiClient.get<SystemSubscriptionsResponse>(
    `/portal/settings/alarms/${controllerId}/subscriptions`,
  )
  return data
}

export async function saveSystemSubscriptions(
  controllerId: string,
  overrides: Record<number, boolean>,
): Promise<{ message: string; topics_updated: number }> {
  const { data } = await apiClient.post(`/portal/settings/alarms/${controllerId}/subscriptions`, { overrides })
  return data
}

export async function resetSystemSubscriptions(
  controllerId: string,
  params: { alarm_topic_ids?: number[]; alarm_severity_id?: number },
): Promise<{ message: string; reset_count: number; topics: Record<string, TopicState> }> {
  const { data } = await apiClient.post(`/portal/settings/alarms/${controllerId}/subscriptions/reset`, params)
  return data
}
